export default "__VITE_ASSET__CO8$nay6__"